import { motion } from "framer-motion";

// Skeleton StatCard Component (Mobile-Optimized)
const SkeletonStatCard = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="bg-gray-200 dark:bg-gray-700 rounded-lg p-2 shadow-md w-full animate-pulse"
  >
    <div className="flex justify-between items-start">
      <div className="space-y-1">
        <div className="h-3 w-16 bg-gray-300 dark:bg-gray-600 rounded"></div>
        <div className="h-5 w-10 bg-gray-300 dark:bg-gray-600 rounded"></div>
        <div className="h-2 w-12 bg-gray-300 dark:bg-gray-600 rounded"></div>
      </div>
      <div className="w-6 h-6 rounded-lg bg-gray-300 dark:bg-gray-600 flex-shrink-0"></div>
    </div>
  </motion.div>
);

// Skeleton Chart Component (Mobile-Optimized)
const SkeletonChart = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="bg-gray-200 dark:bg-gray-700 p-3 rounded-lg shadow-md mb-3 animate-pulse"
  >
    <div className="h-5 w-32 bg-gray-300 dark:bg-gray-600 rounded mb-3"></div>
    <div className="h-40 bg-gray-300 dark:bg-gray-600 rounded"></div>
  </motion.div>
);

// Skeleton OrderCard Component (Mobile-Optimized)
const SkeletonOrderCard = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="bg-gray-200 dark:bg-gray-700 rounded-lg shadow-md p-2 border border-gray-300 dark:border-gray-600 animate-pulse w-full"
  >
    <div className="flex flex-col justify-between items-start">
      <div className="mb-1 space-y-1">
        <div className="h-4 w-20 bg-gray-300 dark:bg-gray-600 rounded"></div>
        <div className="h-3 w-24 bg-gray-300 dark:bg-gray-600 rounded"></div>
        <div className="h-3 w-20 bg-gray-300 dark:bg-gray-600 rounded"></div>
        <div className="h-3 w-28 bg-gray-300 dark:bg-gray-600 rounded"></div>
      </div>
      <div className="h-6 w-full bg-gray-300 dark:bg-gray-600 rounded-lg"></div>
    </div>
  </motion.div>
);

// Skeleton OrdersTable Component (Mobile-Optimized)
const SkeletonOrdersTable = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="overflow-x-auto rounded-lg shadow-md border border-gray-300 dark:border-gray-600 animate-pulse"
  >
    <table className="min-w-full bg-gray-200 dark:bg-gray-700 text-xs">
      <thead className="bg-gray-300 dark:bg-gray-600">
        <tr>
          {Array(7).fill(0).map((_, index) => (
            <th key={index} className="px-1 py-1">
              <div className="h-3 w-12 bg-gray-400 dark:bg-gray-500 rounded"></div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array(5).fill(0).map((_, rowIndex) => (
          <tr key={rowIndex} className="border-t border-gray-300 dark:border-gray-600">
            {Array(7).fill(0).map((_, colIndex) => (
              <td key={colIndex} className="px-1 py-1">
                <div className="h-3 w-16 bg-gray-300 dark:bg-gray-600 rounded"></div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </motion.div>
);

// Skeleton CustomersTable Component (Mobile-Optimized)
const SkeletonCustomersTable = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="overflow-x-auto rounded-lg shadow-md border border-gray-300 dark:border-gray-600 animate-pulse"
  >
    <table className="min-w-full bg-gray-200 dark:bg-gray-700 text-xs">
      <thead className="bg-gray-300 dark:bg-gray-600">
        <tr>
          {Array(6).fill(0).map((_, index) => (
            <th key={index} className="px-1 py-1">
              <div className="h-3 w-12 bg-gray-400 dark:bg-gray-500 rounded"></div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array(5).fill(0).map((_, rowIndex) => (
          <tr key={rowIndex} className="border-t border-gray-300 dark:border-gray-600">
            {Array(6).fill(0).map((_, colIndex) => (
              <td key={colIndex} className="px-1 py-1">
                <div className="h-3 w-16 bg-gray-300 dark:bg-gray-600 rounded"></div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </motion.div>
);

// Skeleton MenuManagement Component (Mobile-Optimized)
const SkeletonMenuManagement = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="bg-gray-200 dark:bg-gray-700 p-3 rounded-lg shadow-md animate-pulse"
  >
    <div className="h-5 w-32 bg-gray-300 dark:bg-gray-600 rounded mb-3"></div>
    <div className="space-y-2">
      {Array(3).fill(0).map((_, index) => (
        <div key={index} className="flex items-center space-x-2">
          <div className="h-10 w-10 bg-gray-300 dark:bg-gray-600 rounded"></div>
          <div className="flex-1 space-y-1">
            <div className="h-3 w-24 bg-gray-300 dark:bg-gray-600 rounded"></div>
            <div className="h-2 w-16 bg-gray-300 dark:bg-gray-600 rounded"></div>
          </div>
          <div className="h-6 w-12 bg-gray-300 dark:bg-gray-600 rounded"></div>
        </div>
      ))}
    </div>
  </motion.div>
);

// Skeleton RolesAndPermissions Component (Mobile-Optimized)
const SkeletonRolesAndPermissions = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="bg-gray-200 dark:bg-gray-700 p-3 rounded-lg shadow-md animate-pulse"
  >
    <div className="h-5 w-32 bg-gray-300 dark:bg-gray-600 rounded mb-3"></div>
    <div className="space-y-2">
      {Array(3).fill(0).map((_, index) => (
        <div key={index} className="flex items-center space-x-2">
          <div className="h-3 w-20 bg-gray-300 dark:bg-gray-600 rounded"></div>
          <div className="h-3 w-12 bg-gray-300 dark:bg-gray-600 rounded"></div>
        </div>
      ))}
    </div>
  </motion.div>
);

// Main SkeletonAdminDashboard Component (Mobile-Optimized)
const SkeletonAdminDashboard = ({ activeTab, activeOrderTab }: { activeTab: string; activeOrderTab: string }) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col text-gray-900 dark:text-white">
      {/* Sidebar Skeleton (Hidden on Mobile) */}
      <div className="hidden w-64 bg-gray-200 dark:bg-gray-700 shadow-lg animate-pulse">
        <div className="p-3">
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-600 rounded"></div>
        </div>
        <div className="px-3 space-y-1">
          {Array(6).fill(0).map((_, index) => (
            <div key={index} className="h-8 w-full bg-gray-300 dark:bg-gray-600 rounded"></div>
          ))}
        </div>
        <div className="p-3 border-t border-gray-300 dark:border-gray-600">
          <div className="h-8 w-full bg-gray-300 dark:bg-gray-600 rounded"></div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <main className="flex-1 px-2 py-3 overflow-y-auto">
        <div className="max-w-full mx-auto">
          {/* Navigation Tabs Skeleton */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="flex flex-wrap space-x-1 mb-3 bg-gray-200 dark:bg-gray-700 p-1 rounded-lg shadow-md animate-pulse"
          >
            {Array(5).fill(0).map((_, index) => (
              <div key={index} className="h-6 w-16 bg-gray-300 dark:bg-gray-600 rounded-md"></div>
            ))}
          </motion.div>

          {activeTab === "dashboard" && (
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <div className="h-6 w-40 bg-gray-300 dark:bg-gray-600 rounded mb-3 animate-pulse"></div>
              <div className="h-3 w-48 bg-gray-300 dark:bg-gray-600 rounded mb-4 animate-pulse"></div>
              <div className="grid grid-cols-2 gap-2 mb-3">
                {Array(8).fill(0).map((_, index) => (
                  <SkeletonStatCard key={index} />
                ))}
              </div>
              <SkeletonChart />
              <SkeletonChart />
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="bg-gray-200 dark:bg-gray-700 p-3 rounded-lg shadow-md mb-3 animate-pulse"
              >
                <div className="h-5 w-32 bg-gray-300 dark:bg-gray-600 rounded mb-3"></div>
                <div className="grid grid-cols-1 gap-2">
                  {Array(3).fill(0).map((_, index) => (
                    <SkeletonOrderCard key={index} />
                  ))}
                </div>
              </motion.div>
            </motion.div>
          )}

          {activeTab === "orders" && (
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <div className="h-6 w-40 bg-gray-300 dark:bg-gray-600 rounded mb-3 animate-pulse"></div>
              <div className="h-3 w-48 bg-gray-300 dark:bg-gray-600 rounded mb-4 animate-pulse"></div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="flex flex-wrap gap-1 mb-3 justify-center animate-pulse"
              >
                {Array(5).fill(0).map((_, index) => (
                  <div key={index} className="h-6 w-20 bg-gray-300 dark:bg-gray-600 rounded-lg"></div>
                ))}
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="bg-gray-200 dark:bg-gray-700 p-2 rounded-lg shadow-md mb-3 flex flex-wrap justify-center gap-1 animate-pulse"
              >
                {Array(5).fill(0).map((_, index) => (
                  <div key={index} className="h-6 w-16 bg-gray-300 dark:bg-gray-600 rounded-full"></div>
                ))}
              </motion.div>
              <SkeletonOrdersTable />
            </motion.div>
          )}

          {activeTab === "customers" && (
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <div className="h-6 w-40 bg-gray-300 dark:bg-gray-600 rounded mb-3 animate-pulse"></div>
              <div className="h-3 w-48 bg-gray-300 dark:bg-gray-600 rounded mb-4 animate-pulse"></div>
              <SkeletonCustomersTable />
            </motion.div>
          )}

          {activeTab === "menu" && (
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <SkeletonMenuManagement />
            </motion.div>
          )}

          {activeTab === "settings" && (
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <SkeletonRolesAndPermissions />
            </motion.div>
          )}
        </div>
      </main>

      {/* Mobile-Specific Styles */}
      <style>{`
        html {
          scroll-behavior: smooth;
        }
        main {
          -webkit-overflow-scrolling: touch;
        }
        .max-w-full {
          padding-left: 0.5rem;
          padding-right: 0.5rem;
        }
        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </div>
  );
};

export default SkeletonAdminDashboard;